import SubscriptionsSelector from '../SubscriptionsSelector'
import { systemRequirementsUrl } from '../../constants'
import { softwareExplainedUrl } from '../../constants'

export default ({ t, i18n, mdarsProducts, cart, addToCart, setSubscription, subscription, language }) => (
  <div className="content">
    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-68')}</li>
        <li>{t('common:mdars-page-content-69')}</li>
      </ul>
    </div>
    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle')}</h4>
    <p><a href={softwareExplainedUrl(i18n.language)} target="_blank">{t('common:subscription-common')}</a></p>
    <div className="m-b-md">
      {t('common:mdars-page-content-7')}
      <div className="columns">
        <div className="column is-4">
        <ul>
            <li>{t('common:mdars-page-content-23')}</li>
            <li>{t('common:mdars-page-content-22')}</li>
            <li>{t('common:mdars-page-content-24')}</li>                    
            <li>{t('common:mdars-page-content-36')}</li>                    
          </ul>
        </div>
        <div className="column is-4">
          <ul>          
            <li>{t('common:mdars-page-content-21')}</li>                    
            <li>{t('common:mdars-page-content-20')}</li>
            <li>{t('common:mdars-page-content-18')}</li>
            <li>{t('common:mdars-page-content-37')}</li>            
          </ul>
        </div>
        <div className="column is-4">
          <ul>
            <li>{t('common:mdars-page-content-17')}</li>          
            <li>{t('common:mdars-page-content-9')}</li>
         <li>{t('common:mdars-page-content-8')}</li>
            <li>{t('common:mdars-page-content-38')}</li>            
        </ul>
        </div>
      </div> 
    </div>

    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-subtitle-2')}</h4>
    <div className="m-b-md">
      <div>{t('common:mdars-page-content-25')}</div>
      <ul>
        <li>{t('common:mdars-page-content-26')}</li>        
      </ul>
    </div>

    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-13')}</li>
        <li>{t('common:mdars-page-content-1')}</li>
        <li>{t('common:mdars-page-content-14')}</li>
        <li>{t('common:mdars-page-content-4')}</li>
      </ul>
    </div>

    <h4 className="is-size-4 m-b-md">{t('common:mdars-page-content-2')}</h4>
    <div className="m-b-md">
      <div>{t('common:mdars-page-content-27')}</div>      
    </div>
    <div className="m-b-md">{t('common:mdars-page-content-12')}
      <ul>
        <li>{t('common:mdars-page-content-40')}</li>
        <li>{t('common:mdars-page-content-41')}</li>        
      </ul>
    </div>
    <div className="m-b-md">
      <table className="table is-bordered login-history-list">
        <thead>
          <tr>
            <th colSpan="2">{t('common:mdars-page-content-28')}</th>            
          </tr>
        </thead>
        <tbody>                      
            <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-42')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-43')}</td>
            </tr>          
            <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-44')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-46')}</td>
            </tr>
            <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-47')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-48')}</td>
            </tr>
            <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-49')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-50')}</td>
            </tr>          
        </tbody>
      </table>      
    </div>

    <div className="m-b-md">
      <table className="table is-bordered login-history-list">
        <thead>
          <tr>
            <th colSpan="2">{t('common:mdars-page-content-51')}</th>
          </tr>
        </thead>
        <tbody>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-52')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-54')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-55')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-56')}</td>
          </tr>
          <tr className="login-history-list ">
            <td>{t('common:mdars-page-content-57')}</td>
            <td className="has-text-centered">{t('common:mdars-page-content-58')}<br />{t('common:mdars-page-content-59')}</td>
          </tr>          
        </tbody>
      </table>
    </div>

    <div className="m-b-md">
      {t('common:mdars-page-content-60')}
      <ul>
        <li>{t('common:mdars-page-content-61')}</li>
        <li>{t('common:mdars-page-content-62')}</li>
        <li>{t('common:mdars-page-content-63')}</li>
      </ul>
    </div>

    <div className="m-b-md">
      {t('common:mdars-page-content-64')}
      <ul>
        <li>{t('common:mdars-page-content-65')}</li>
        <li>{t('common:mdars-page-content-66')}</li>        
      </ul>
    </div>

    <SubscriptionsSelector
      products={mdarsProducts}
      subscription={subscription}
      setSubscription={setSubscription}
      addToCart={addToCart}
      cart={cart}
      language={language}
      t={t} />
    
  </div>
)



// WEBPACK FOOTER //
// ./components/MDARSSoftware/index.js